<template>
	<div class="item-param display-flex flex-column">
		<ParamDispatcherDataProvider
			v-for="nestedParam in visibleNestedParams"
			class="item-param-dispatcher"
			:param="nestedParam"
			:node="itemNode"
			:key="buildFieldKey(nestedParam)"
			:workflowVersion="workflowVersion"
			@update-input-field="updateInputField"
			@update-input-field-label="updateInputFieldLabel"
			@update-input-fallback="updateInputFallback"
			v-bind="$attrs"
		/>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import ParamsService from '@/utils/ParamsService';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
import { editNodeOriginal } from '@/store/modules/selectedNode/getters';

export default {
	name: 'ItemPropertyInput',
	components: {
		ParamDispatcherDataProvider: () => import('@/components/BlockEditor/BlockEditorParams/ParamDispatcherDataProvider'),
	},
	props: {
		param: { type: Object },
		node: { type: Object },
		workflowVersion: { type: Object },
		value: { type: [String, Number, Boolean, Array, Object] },
	},
	mixins: [],
	methods: {
		updateInputField(payload) {
			const { map, label /*, param*/ } = payload;
			this.$set(this.itemParamsMap, map.key, map.value);

			const mapItem = { key: this.param.key, value: this.itemParamsMap };
			// Important to pass current item param as the
			// updated param and not the nested one
			const body = { map: mapItem, param: this.param };
			if (label) {
				this.$set(this.itemParamsMapLabels, label.key, label.value);
				const labelItem = { key: this.param.key, value: this.itemParamsMapLabels };
				body.label = labelItem;
			}
			this.$emit('update-input-field', body);
		},
		updateInputFieldLabel(payload) {
			const { label } = payload;
			this.$set(this.itemParamsMapLabels, label.key, label.value);
			this.$emit('update-input-field-label', { label: this.itemParamsMapLabels });
		},
		updateInputFallback(payload) {
			const { key, value } = payload;
			this.$set(this.itemFallbacks, key, value);
			this.$emit('update-input-fallback', this.itemFallbacks);
		},
		buildFieldKey(param) {
			return ParamsService.buildFieldKey(param, this.itemParamsMap);
		},
		setInitialState() {
			if (!this.itemParamsMap) {
				this.$set(this.localField.params_map, this.param.key, {});
			}
			if (!this.itemParamsMapLabels) {
				this.$set(this.localField.params_map_labels, this.param.key, {});
			}
			if (!this.itemFallbacks) {
				this.$set(this.localField.fallbacks, this.param.key, {});
			}
		},
	},
	computed: {
		...mapGetters([editNodeOriginal.fullPath]),
		visibleNestedParams() {
			return this.param.params.filter((p) => !p.hidden);
		},
		isDropdownOpen() {
			return this.localIsDropdownOpen || !this.allRequiredFieldsFilled;
		},
		allRequiredFieldsFilled() {
			return this.param.params
				.filter((pa) => pa.required)
				.every((pa) => {
					if (!this.itemParamsMap.hasOwnProperty(pa.key)) {
						return false;
					}
					const value = this.itemParamsMap[pa.key];
					return !isNullOrUndefinedOrEmpty(value);
				});
		},
		itemParamsMap() {
			return this.localField?.params_map?.[this.param.key];
		},
		itemParamsMapLabels() {
			return this.localField?.params_map_labels?.[this.param.key];
		},
		itemFallbacks() {
			return this.localField?.fallbacks?.[this.param.key] || {};
		},
		itemNode() {
			return {
				...this.localField,
				params_map: this.itemParamsMap,
				params_map_labels: this.itemParamsMapLabels,
				fallbacks: this.itemFallbacks,
			};
		},
	},
	mounted() {
		this.setInitialState();
	},
	data() {
		return {
			localField: cloneDeep(this.node),
			localIsDropdownOpen: true,
		};
	},
};
</script>
<style lang="scss" scoped>
.item-param {
	border: 1px solid var(--seconday-border-color);
	border-radius: 5px;
	padding: 10px;
	margin-top: 10px;
}
</style>
